import React, { useState, useEffect, ReactNode } from "react";
import { connect } from "react-redux";
import { User } from "~/common/Store/models/User";
import { RootState } from "~/common/Store/models/RootReadonly";
import loginModalStore from "~/common/LoginModal/loginModalStore";

interface Props {
  children: ReactNode;
  className?: string;
  user: User;
  disableDefaultStyles?: boolean;
}

const LoginLink = ({
  children,
  className = "",
  disableDefaultStyles,
}: Props) => {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    setCurrentUrl(window.location.pathname + window.location.search);
  }, []);

  const linkStyles = "text-green-500 hover:text-green-900 underline";

  return (
    <a
      className={`map-login-link ${
        disableDefaultStyles ? "" : linkStyles
      } ${className}`}
      onClick={(e) => {
        e.preventDefault();
        loginModalStore.openLogin({
          targetUrl: window.location.pathname,
          queryParams: window.location.search,
        });
      }}
      href={`/myaccount/?target_url=${encodeURIComponent(currentUrl)}`}
      data-toggle="loginModal"
    >
      {children}
    </a>
  );
};

export const mapStateToProps = (state: RootState) => ({ user: state.user });

export default connect(mapStateToProps)(LoginLink);
